module.exports = __webpack_public_path__ + "img/多领域服务4.32a939f7.jpg";